/* GIST LIBRARY — Audio Summaries page (gxa-*)
   Topic filter (an accessible tablist over a card grid) + optional shortest-first sort.
   Dependency-free · idempotent · reduced-motion safe · no-JS fallback shows all cards.
   The hero .gx-ap player is owned by gist-premium-pages.js; its ARIA by gist-focus.js —
   this file never touches the player. */
(function () {
  'use strict';
  if (window.__gxaLoaded) return;
  window.__gxaLoaded = true;

  var uid = 0;

  function once(el) {
    if (el.hasAttribute('data-gxa-init')) return false;
    el.setAttribute('data-gxa-init', '1');
    return true;
  }

  function initLibrary(root) {
    (root || document).querySelectorAll('.gxa-library').forEach(function (sec) {
      if (!once(sec)) return;

      var pillsWrap = sec.querySelector('.gxa-filter__pills');
      var pills = Array.prototype.slice.call(sec.querySelectorAll('.gxa-pill'));
      var grid = sec.querySelector('.gxa-grid');
      var slots = Array.prototype.slice.call(sec.querySelectorAll('.gxa-slot'));
      var status = sec.querySelector('.gxa-filter__status');

      /* Missing pieces -> leave the no-JS view (all cards visible, pills hidden). */
      if (!pillsWrap || !pills.length || !grid || !slots.length) return;

      sec.classList.add('gxa-js');
      grid.id = grid.id || ('gxa-grid-' + (++uid));
      var origOrder = slots.slice();      /* cache the authored order for "unsort" */

      pillsWrap.setAttribute('role', 'tablist');
      grid.setAttribute('role', 'region');
      grid.setAttribute('aria-label', 'Audio summaries');

      pills.forEach(function (pill, i) {
        pill.setAttribute('role', 'tab');
        pill.setAttribute('aria-controls', grid.id);
        pill.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        pill.tabIndex = i === 0 ? 0 : -1;
      });

      function apply(topic) {
        var shown = 0;
        slots.forEach(function (s) {
          var have = ' ' + (s.getAttribute('data-topic') || '') + ' ';
          var on = !topic || have.indexOf(' ' + topic + ' ') > -1;
          s.hidden = !on;
          if (on) shown++;
        });
        if (status) {
          status.textContent = topic
            ? ('Showing ' + shown + ' of ' + slots.length)
            : ('Showing all ' + slots.length);
        }
      }

      function select(idx, focus) {
        pills.forEach(function (p, i) {
          var on = i === idx;
          p.setAttribute('aria-selected', on ? 'true' : 'false');
          p.tabIndex = on ? 0 : -1;
        });
        apply(pills[idx].getAttribute('data-topic') || '');
        if (focus) pills[idx].focus();
      }

      pills.forEach(function (pill, i) {
        pill.addEventListener('click', function () { select(i, false); });
        pill.addEventListener('keydown', function (ev) {
          var to = null;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') to = (i + 1) % pills.length;
          if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') to = (i - 1 + pills.length) % pills.length;
          if (ev.key === 'Home') to = 0;
          if (ev.key === 'End') to = pills.length - 1;
          if (to === null) return;
          ev.preventDefault();
          select(to, true);
        });
      });

      apply('');   /* initial state: All */

      /* Optional shortest-first sort (button rendered only when enabled). */
      var sortBtn = sec.querySelector('.gxa-sort');
      if (sortBtn) {
        var sorted = false;
        sortBtn.setAttribute('aria-pressed', 'false');
        sortBtn.addEventListener('click', function () {
          sorted = !sorted;
          sortBtn.setAttribute('aria-pressed', sorted ? 'true' : 'false');
          var arr = origOrder.slice();
          if (sorted) {
            arr.sort(function (a, b) {
              return (parseInt(a.getAttribute('data-duration'), 10) || 0) -
                     (parseInt(b.getAttribute('data-duration'), 10) || 0);
            });
          }
          arr.forEach(function (s) { grid.appendChild(s); });   /* reorder DOM in place */
        });
      }
    });
  }

  function initAll(root) { initLibrary(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
